import effectManager from '../../module/effect';

let effect = new effectManager();

export default class transitionManager {
    constructor(winodwWidth,ua) {

        this.ua = Useragnt.tablet ? "pc" : ua;
        this.exUa = this.ua === "pc" ? "sp" : "pc";

        this.w;
        this.h;

        this.$container = $("#p-act");
        this.$body = this.$container.find(".p-act-day-body");
        this.$artist = this.$container.find(".p-act-day-body-artist");
        this.$bg = this.$container.find(".p-act-day-body-artist-bg");

        this.$headerCnt = this.ua === "pc" ? $("#l-scrolldown,#l-header-navi-list li") : $("#l-scrolldown,#l-header-title .l-logo,#l-header-navi-trigger");

        this.selectID;

        effect.show(this.$container.find(".js__detail-show").not(".ua-ef-"+this.exUa),"set");
        effect.show(this.$container.find(".js__thum-detail-show").not(".ua-ef-"+this.exUa),"set");
        effect.bgImg(this.$bg,"set");
        effect.splitText(this.$container.find(".js__detail-splittext"),"set");


        /* スマホはオープン前に高さを取得 */

    }
    start(mode,selectID,selectArtistID,outID,day){

        let _dir = day == "18" ? 1 : -1;

        if(mode==="open"){
            this.animationShow(selectID,selectArtistID,outID,_dir);
        }else{
            this.animationOut(selectID,selectArtistID,outID);
        }

    }
    change(selectID,day,showArtist,outArtist){


        TweenMax.killTweensOf($(showArtist));
        TweenMax.killTweensOf($(outArtist));

        //p-act_18_nick
        let _showArtistId = selectID+" #p-act_"+day+"_"+showArtist,
            _outArtistId = selectID+" #p-act_"+day+"_"+outArtist;



        effect.show($(_outArtistId).find(".js__detail-show").not(".ua-ef-"+this.exUa),"out");
        effect.splitText($(_outArtistId+" .js__detail-splittext >* >*"),"out");

        let _this = this;
        setTimeout(function () {
            $(_outArtistId).removeClass("is-current");
            $(_showArtistId).addClass("is-current");
            effect.bgImg($(_outArtistId+" .p-act-day-body-artist-bg >* >*"),"out");
            effect.bgImg($(_showArtistId+" .p-act-day-body-artist-bg >* >*"),"show");
            effect.show($(_showArtistId).find(".js__detail-show").not(".ua-ef-"+_this.exUa),"show");
            effect.splitText($(_showArtistId+" .js__detail-splittext >* >*"),"show");
        },1e3);


    }
    animationShow(selectID,selectArtistID,outID,dir){

        let _this = this;

        $(selectID+" .p-act-day-thum").addClass("is-current");
        TweenMax.killTweensOf($(selectID).find(".js__thum-show").not(".ua-ef-"+_this.exUa));
        effect.show($(selectID).find(".js__thum-show").not(".ua-ef-"+_this.exUa),"out");
        TweenMax.killTweensOf(this.$headerCnt);
        effect.show(this.$headerCnt,"out");
        $("#l-header-navi-list").addClass("is-none")

        let _callback = ()=>{
            _this.$body.addClass("is-current");
            $(selectID).addClass("is-current");
            $(selectArtistID).addClass("is-current");
        }

        if(this.ua==="pc"){

            TweenMax.to($(selectID+" .p-act-day-thum"),0.9,{
                width : 33 + "%",
                delay:0.3,
                // ease: Power2.easeOut
                ease: Power2.easeInOut
            });

            TweenMax.to($(outID+" .p-act-day-thum"),0.4,{
                x : 100*dir + "%",
                delay:0.3,
                ease: Power2.easeInOut
            });
            TweenMax.to($(selectID+" .p-act-day-body"),0.9,{
                x : 0+"%",
                delay:0.3,
                ease: Power2.easeInOut,
                onComplete:_callback
            });

        }else{


            TweenMax.to($(selectID+" .p-act-day-thum"),0.9,{
                height : 70,
                delay:1,
                // ease: Power2.easeOut
                ease: Power2.easeInOut
            });

            TweenMax.to($(outID+" .p-act-day-thum"),0.4,{
                y : 100*dir + "%",
                delay:1,
                ease: Power2.easeInOut
            });
            TweenMax.to($(selectID+" .p-act-day-body"),0.9,{
                x : 0+"%",
                delay:1,
                ease: Power2.easeInOut,
                onComplete:_callback
            });

        }


        let _delay = this.ua === "pc" ? 5e2 : 2e3;
        setTimeout(function () {
            effect.bgImg($(selectArtistID+" .p-act-day-body-artist-bg >* >*"),"show");
            effect.show($(selectArtistID).find(".js__detail-show").not(".ua-ef-"+_this.exUa),"show");
            effect.show($(selectID).find(".js__thum-detail-show").not(".ua-ef-"+_this.exUa),"show");
            effect.splitText($(selectArtistID+" .js__detail-splittext >* >*"),"show");
        },_delay);

    }
    animationOut(selectID,selectArtistID,outID){

        let _this = this;

        $(selectID).removeClass("is-current");
        $(selectArtistID).removeClass("is-current");
        this.$body.removeClass("is-current");
        effect.show($(selectArtistID).find(".js__detail-show").not(".ua-ef-"+this.exUa),"out");
        effect.show($(selectID).find(".js__thum-detail-show").not(".ua-ef-"+this.exUa),"out");
        effect.splitText($(selectArtistID+" .js__detail-splittext >* >*"),"out");
        effect.bgImg($(selectArtistID+" .p-act-day-body-artist-bg >* >*"),"out");

        setTimeout(()=> {

            let _callback = ()=>{
                effect.show($(selectID).find(".js__thum-show").not(".ua-ef-"+this.exUa),"show");

                if(this.ua ==="pc")
                    effect.show(_this.$headerCnt,"show");
                else
                    effect.show(_this.$headerCnt,"show");

                $("#l-header-navi-list").removeClass("is-none")
                setTimeout(()=>$(selectID+" .p-act-day-thum").removeClass("is-current"),1e3)
            }

            let _delay = 0.4;

            if(_this.ua==="pc"){
                TweenMax.to($(selectID+" .p-act-day-thum"),0.6,{
                    width : 100 + "%",
                    delay:_delay,
                    ease: Power2.easeOut,
                    onComplete:_callback
                });
                TweenMax.to($(outID+" .p-act-day-thum"),0.5,{
                    x : 0 + "%",
                    delay:_delay,
                    ease: Power2.easeOut,
                });
                TweenMax.to($(selectID+" .p-act-day-body"),0.6,{
                    // x : this.w/2-10,
                    x : 50+"%",
                    delay:_delay,
                    ease: Power2.easeOut
                });
            }else{
                TweenMax.to($(selectID+" .p-act-day-thum"),0.6,{
                    height : 100+"vh",
                    y : 0,
                    delay:_delay,
                    ease: Power2.easeOut,
                    onComplete:_callback
                });
                TweenMax.to($(outID+" .p-act-day-thum"),0.5,{
                    y : 0 + "%",
                    delay:_delay,
                    ease: Power2.easeOut,
                });
                TweenMax.to($(selectID+" .p-act-day-body"),0.6,{
                    // x : this.w/2-10,
                    x : 50+"%",
                    delay:_delay,
                    ease: Power2.easeOut
                });
            }

            setTimeout(()=> effect.bgImg($(selectID+" .p-act-day-body-artist-bg >* >*"),"out"),1e2);


        },5e2);


    }
    render(){

    }
    resize(w,h){
        this.w = w;
        this.h = h;
        // TweenMax.set(this.$detail,{ x:this.w/2-10 })

    }
}